import React from 'react';
import { BrandColor } from '@styleseat/brand';

type BasicHalfStarFilledIconProps = {
  width?: number;
  height?: number;
  color?: string;
  outlineColor?: string;
  testID?: string;
  backgroundColor?: string;
} & React.SVGProps<SVGSVGElement>;

export const BasicHalfStarFilledIcon = ({
  width = 24,
  height = 24,
  color = BrandColor.BackInBlack,
  outlineColor,
  backgroundColor = BrandColor.Transparent,
  testID,
}: BasicHalfStarFilledIconProps) => (
  <svg
    data-testid={testID}
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient id="grad">
        <stop offset="50%" stopColor={color} />
        <stop offset="50%" stopColor={backgroundColor} />
      </linearGradient>
      <linearGradient id="strokegrad">
        <stop offset="50%" stopColor={outlineColor ? color : BrandColor.Transparent} />
        <stop offset="50%" stopColor={outlineColor || BrandColor.Transparent} />
      </linearGradient>
    </defs>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.17269 12.7532L3.41237 15.2788L4.32151 9.92949L0.470337 6.14108L5.79253 5.36063L8.17269 0.493652L10.5528 5.36063L15.875 6.14108L12.0239 9.92949L12.933 15.2788L8.17269 12.7532Z"
      fill="url(#grad)"
      stroke="url(#strokegrad)"
    />
  </svg>
);
